module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/baylor-university-716d875b6aeee598480a5b553033b7bf.svg";